var character_is_revealed = false;
var character_list;
var current_character;

async function setupStandardRitualV3() {
    console.log("Setting up standard ritual.");
    await setupRitualList((character) => character["main-character"] == true);
}

async function setupLongRitualV3() {
    console.log("Setting up long ritual.");
    await setupRitualList();
}

async function setupRitualList(filtering_method = null) {
    console.log("Loading ritual file.");
    let fetched_list_of_characters = await fetch("/assets/json/ritual-data.json");
    let list_of_characters = await fetched_list_of_characters.json();

    if (filtering_method != null) {
        list_of_characters = list_of_characters.filter(filtering_method);
    }

    shuffle(list_of_characters);

    sessionStorage.setItem("ritualCharacterList", JSON.stringify(list_of_characters))
    
    window.location.href = new URL("/ritual/ritual-v3", window.location.href).href;
}

function ritualV3Button() {
    if (!character_is_revealed) { 
        console.log("Character not revealed, revealing.");
        character_is_revealed = true;
        ritualV3Reveal();
    }
    else {
        console.log("Progressing in ritual.");
        character_is_revealed = false;
        ritualV3Progress();
    }
}

function ritualV3Reveal() {
    var nameTag = document.getElementById("ritual-v3-name");
    var powerTag = document.getElementById("ritual-v3-power");
    var buttonTag = document.getElementById("ritual-v3-button");
    var powerExplanationTag = document.getElementById("ritual-v3-power-desc");

    nameTag.innerHTML = current_character["name"];
    powerTag.innerHTML = current_character["power"];
    powerExplanationTag.innerHTML = current_character["power-desc"];
    powerExplanationTag.style.display = "block";
    buttonTag.innerHTML = "NEXT →";
}

function ritualV3Progress() {
    console.log("Loading next character, " + character_list.length + " remaining.");

    if (character_list.length > 0) {
        current_character = character_list.pop();

        var nameTag = document.getElementById("ritual-v3-name");
        var artTag = document.getElementById("ritual-v3-art");
        var powerTag = document.getElementById("ritual-v3-power");
        var buttonTag = document.getElementById("ritual-v3-button");
        var powerExplanationTag = document.getElementById("ritual-v3-power-desc");
        var guessedCharactersTag = document.getElementById("ritualDone");

        artTag.src = "/assets/img/pd-logo.svg"; // To make the image visibly changed.
        artTag.src = "/assets/img/" + current_character["img"];
        nameTag.innerHTML = "NAME?";
        powerTag.innerHTML = "POWER?";
        powerExplanationTag.innerHTML = "???";
        powerExplanationTag.style.display = "none";
        buttonTag.innerHTML = "REVEAL";

        guessedCharactersTag.innerHTML = parseInt(guessedCharactersTag.innerHTML) + 1;
    }
    else {
        console.log("Finished ritual!");
        window.location.href = new URL("/ritual/complete", window.location.href).href;
    }
}

function initializeRitual() {
    character_list = JSON.parse(sessionStorage.getItem("ritualCharacterList"));
    sessionStorage.removeItem("ritualCharacterList");

    var totalRemainingTag = document.getElementById("ritualTotal");
    totalRemainingTag.innerHTML = character_list.length;
    
    ritualV3Progress();
}

function shuffle(array) {
    console.log("Starting shuffle");
    let currentIndex = array.length;
    // While there remain elements to shuffle...
    while (currentIndex != 0) {
        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
}

// Give window permission to use the relevant functions.
Object.assign(window, {
    setupStandardRitualV3,
    setupLongRitualV3,
    initializeRitual,
    ritualV3Button
});